import Vue from 'vue'
import Router from 'vue-router'
import Login from './loginRoute'
import Dashboard from './dashboardRoute'
import Constants from '../components/Constants'

//解决ElementUI导航栏中的vue-router在3.0版本以上重复点击菜单报错问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};
Vue.use(Router);
let routes = new Set([...Login,...Dashboard]);
const router = new Router({
  routes
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.auth)) {  // 判断该路由是否需要登录权限
    if (sessionStorage.getItem(Constants.LOGIN_STATE) === '200') {  // 判断当前用户的登录信息是否存在
      next();
    } else {
      next({path: '/'});
    }
  } else {
    next();
  }
});
router.afterEach((to,from) =>{

});
export default router;



// WEBPACK FOOTER //
// ./src/router/router.js